var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('snack-bar'),_c('sidebar'),_c('v-main',[_c('v-container',{staticClass:"lfs-container",attrs:{"fluid":""}},[_c('router-view')],1)],1),_c('full-dialog')],1)}
var staticRenderFns = []

export { render, staticRenderFns }